module.exports = __webpack_public_path__ + "media/images/site/fundamental2_patio-349412886767808f35ca71e43c6e19ad.jpg";